import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderContentSort } from '../../services';

export const fetchSliderContentSort = createAsyncThunk(
    'sliderContentSort/fetchSliderContentSort',
    async ({ id, sort }) => {
        const response = await SliderContentSort(id, sort)
        return response.result
    }
)

const sliderContentSortSlice = createSlice({
    name: 'sliderContentSort',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderContentSort.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderContentSort.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderContentSort.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderContentSortSlice.reducer;
